import * as ko from "knockout";
import { calendar_exception } from "entitiesE";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";
import { exception_type } from "organized";
import { format } from "date-fns";

class UserCalendarService extends BaseService {
  constructor() {
    super("userCalendar");
  }

  public getExceptionTypes = async (): Promise<exception_type[]> => {
    const data = await portalHttpService.get<exception_type[]>(`${this.baseApiUrl()}/GetExceptionTypes`);
    return data.map((item) => new exception_type(item));
  };

  public getCalendarData = async (startDate: Date, endDate: Date): Promise<calendar_exception[]> => {
    const urlResult = new URL(`${this.baseApiUrl()}/GetCalendarData`);
    urlResult.searchParams.append("startDate", format(startDate, "yyyy-MM-dd'T'HH:mm:ss"));
    urlResult.searchParams.append("endDate", format(endDate, "yyyy-MM-dd'T'HH:mm:ss"));

    const data = await portalHttpService.get<any[]>(urlResult.href);
    const exceptions = data.map((item) => new calendar_exception(item));

    // Sort by start date
    return exceptions.sort((a, b) => {
      const dateA = a.start_dttm();
      const dateB = b.start_dttm();
      return dateA.getTime() - dateB.getTime();
    });
  };

  public saveCalendarException = (exception: calendar_exception): Promise<calendar_exception> => {
    return portalHttpService.post<any>(
      `${this.baseApiUrl()}/SaveCalendarException`,
      ko.toJSON({
        exception_id: exception.exception_id(),
        start_date: format(exception.start_dttm(), "yyyy-MM-dd'T'HH:mm:ss"),
        end_date: format(exception.end_dttm(), "yyyy-MM-dd'T'HH:mm:ss"),
        description: exception.description(),
        exception_type: exception.exception_type(),
      }),
    );
  };

  public deleteCalendarException = (exceptionId: number): Promise<void> => {
    return portalHttpService.post<void>(`${this.baseApiUrl()}/DeleteCalendarException/${exceptionId}`);
  };
}

export const userCalendarService = new UserCalendarService();
